// TinyMCE settings for the LexiQamus CMS admin page form (lab.lexiqamus.com uses TinyMCE 5).
export const TINYMCE_VERSION = '5.10.9'
export const TINYMCE_SELF_HOSTED_BASE_URL = `https://cdn.jsdelivr.net/npm/tinymce@${TINYMCE_VERSION}`

// Editor UI color constants synchronized with $lexiqamus-* SCSS variables in lexiqamus.scss
export const TINYMCE_BODY_TEXT_COLOR   = '#334155'
export const TINYMCE_TABLE_CELL_BORDER = '#dddddd'
export const TINYMCE_BLOCKQUOTE_BORDER = '#cbd5e1'
export const TINYMCE_NON_EDITABLE_BG   = '#f5f5f5'

// Marks <style> nodes we inject into the editor iframe head (vs author <style> in body).
export const TINYMCE_CMS_EMBEDDED_STYLE_ATTR  = 'data-lq-cms-embedded'
export const TINYMCE_CMS_EMBEDDED_STYLE_VALUE = '1'
